import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

import { getDiscountedCategoriesInAbsoluteNumber } from './utils';

const initialState = {
  data: {
    content: [],
    links: [],
    page: {},
  },
  apiError: null,
  isFetching: false,
  categories: {},
};

const initialStateTop = {
  isFetching: true,
  apiError: null,
};

const fetchCategoriesStatsRequest = state => ({
  ...state,
  isFetching: true,
  apiError: null,
});

const fetchCategoriesStatsSuccess = (state, { data }) => ({
  ...state,
  data: {
    ...data,
    content: getDiscountedCategoriesInAbsoluteNumber(data.content),
  },
  isFetching: false,
  apiError: null,
});

const fetchCategoriesStatsFailure = (state, { error }) => ({
  ...state,
  isFetching: false,
  apiError: error,
});

const fetchCategoriesStatsContributorTopAuthorRequest = (state, { payload }) => {
  const category = payload?.params?.category;
  return {
    ...state,
    categories: {
      ...state?.categories,
      [category]: {
        ...state.categories[category],
        topAuthor: initialStateTop,
      },
    },
  };
};

const fetchCategoriesStatsContributorTopAuthorSuccess = (state, { data, meta }) => {
  const category = meta?.category;
  return {
    ...state,
    categories: {
      ...state?.categories,
      [category]: {
        ...state.categories[category],
        topAuthor: {
          ...state.categories?.[category]?.topSender,
          data: data?.content,
          isFetching: false,
        },
      },
    },
  };
};

const fetchCategoriesStatsContributorTopAuthorFailure = (state, { error, meta }) => {
  const category = meta?.category;
  return {
    ...state,
    categories: {
      ...state?.categories,
      [category]: {
        ...state.categories[category],
        topAuthor: {
          isFetching: false,
          apiError: error,
        },
      },
    },
  };
};

const fetchCategoriesStatsContributorTopSenderRequest = (state, { payload }) => {
  const category = payload?.params?.category;
  return {
    ...state,
    categories: {
      ...state?.categories,
      [category]: {
        ...state.categories[category],
        topSender: initialStateTop,
      },
    },
  };
};

const fetchCategoriesStatsContributorTopSenderSuccess = (state, { data, meta }) => {
  const category = meta?.category;
  return {
    ...state,
    categories: {
      ...state?.categories,
      [category]: {
        ...state.categories[category],
        topSender: {
          ...state.categories?.[category]?.topSender,
          data: data?.content,
          isFetching: false,
        },
      },
    },
  };
};

const fetchCategoriesStatsContributorTopSenderFailure = (state, { error, meta }) => {
  const category = meta?.category;
  return {
    ...state,
    categories: {
      ...state?.categories,
      [category]: {
        ...state.categories[category],
        topSender: {
          isFetching: false,
          apiError: error,
        },
      },
    },
  };
};

export default createReducer(initialState, {
  [types.FETCH_CATEGORIES_STATS_CONTRIBUTOR_REQUEST]: fetchCategoriesStatsRequest,
  [types.FETCH_CATEGORIES_STATS_CONTRIBUTOR_SUCCESS]: fetchCategoriesStatsSuccess,
  [types.FETCH_CATEGORIES_STATS_CONTRIBUTOR_FAILURE]: fetchCategoriesStatsFailure,
  [types.FETCH_CATEGORIES_STATS_CONTRIBUTOR_TOP_AUTHOR_REQUEST]: fetchCategoriesStatsContributorTopAuthorRequest,
  [types.FETCH_CATEGORIES_STATS_CONTRIBUTOR_TOP_AUTHOR_SUCCESS]: fetchCategoriesStatsContributorTopAuthorSuccess,
  [types.FETCH_CATEGORIES_STATS_CONTRIBUTOR_TOP_AUTHOR_FAILURE]: fetchCategoriesStatsContributorTopAuthorFailure,
  [types.FETCH_CATEGORIES_STATS_CONTRIBUTOR_TOP_SENDER_REQUEST]: fetchCategoriesStatsContributorTopSenderRequest,
  [types.FETCH_CATEGORIES_STATS_CONTRIBUTOR_TOP_SENDER_SUCCESS]: fetchCategoriesStatsContributorTopSenderSuccess,
  [types.FETCH_CATEGORIES_STATS_CONTRIBUTOR_TOP_SENDER_FAILURE]: fetchCategoriesStatsContributorTopSenderFailure,
});
